const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                context.proxy[`label_tag_name`] = (((context.has(`label_tag_name`))) ? (this.env.getFilter('default').traceableCallable(1, this.source)(...[(context.has(`label_tag_name`) ? context.get(`label_tag_name`) : null), `h2`])) : (`h2`));
                context.proxy[`label_id`] = (((context.has(`label_id`))) ? (this.env.getFilter('default').traceableCallable(2, this.source)(...[(context.has(`label_id`) ? context.get(`label_id`) : null), `pagination-label`])) : (`pagination-label`));
                this.echo(`
<nav class="c-pagination" aria-labelledby="`);
                this.echo(this.env.getFilter('escape').traceableCallable(4, this.source)(...[this.env, (context.has(`label_id`) ? context.get(`label_id`) : null), `html`, null, true]));
                this.echo(`">
  <`);
                this.echo(this.env.getFilter('escape').traceableCallable(5, this.source)(...[this.env, (context.has(`label_tag_name`) ? context.get(`label_tag_name`) : null), `html`, null, true]));
                this.echo(` id="`);
                this.echo(this.env.getFilter('escape').traceableCallable(5, this.source)(...[this.env, (context.has(`label_id`) ? context.get(`label_id`) : null), `html`, null, true]));
                this.echo(`" class="u-hidden-visually">Pagination</`);
                this.echo(this.env.getFilter('escape').traceableCallable(5, this.source)(...[this.env, (context.has(`label_tag_name`) ? context.get(`label_tag_name`) : null), `html`, null, true]));
                this.echo(`>
  <ul class="c-pagination__items" role="list">
    `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(this.traceableMethod(this.getAttribute, 7, this.source)(this.env, (context.has(`pagination`) ? context.get(`pagination`) : null), `pages`, new Map([]), `any`, false, false, false));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`page`] = __value__;
                    this.echo(`      <li class="c-pagination__item">
        `);
                    if (this.traceableMethod(this.getAttribute, 9, this.source)(this.env, context.get(`page`), `current`, new Map([]), `any`, false, false, false)) {
                        this.echo(`          <a class="c-pagination__action" href="`);
                        this.echo(this.env.getFilter('escape').traceableCallable(10, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 10, this.source)(this.env, context.get(`page`), `link`, new Map([]), `any`, false, false, false), `html`, null, true]));
                        this.echo(`" aria-current="page">
            <span class="u-hidden-visually">Page</span>
            <span class="c-pagination__number">`);
                        this.echo(this.env.getFilter('escape').traceableCallable(12, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 12, this.source)(this.env, context.get(`page`), `title`, new Map([]), `any`, false, false, false), `html`, null, true]));
                        this.echo(`</span>
          </a>
        `);
                    }
                    else if (!!(this.traceableMethod(this.getAttribute, 14, this.source)(this.env, context.get(`page`), `link`, new Map([]), `any`, false, false, false) && this.compare(this.traceableMethod(this.getAttribute, 14, this.source)(this.env, context.get(`page`), `link`, new Map([]), `any`, false, false, false), this.traceableMethod(this.getAttribute, 14, this.source)(this.env, this.traceableMethod(this.getAttribute, 14, this.source)(this.env, (context.has(`pagination`) ? context.get(`pagination`) : null), `prev`, new Map([]), `any`, false, false, false), `link`, new Map([]), `any`, false, false, false)))) {
                        this.echo(`          <a class="c-pagination__action is-previous" href="`);
                        this.echo(this.env.getFilter('escape').traceableCallable(15, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 15, this.source)(this.env, context.get(`page`), `link`, new Map([]), `any`, false, false, false), `html`, null, true]));
                        this.echo(`">
            <span class="u-hidden-visually">Previous: Page</span>
            <span class="c-pagination__number">`);
                        this.echo(this.env.getFilter('escape').traceableCallable(17, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 17, this.source)(this.env, context.get(`page`), `title`, new Map([]), `any`, false, false, false), `html`, null, true]));
                        this.echo(`</span>
          </a>
        `);
                    }
                    else if (!!(this.traceableMethod(this.getAttribute, 19, this.source)(this.env, context.get(`page`), `link`, new Map([]), `any`, false, false, false) && this.compare(this.traceableMethod(this.getAttribute, 19, this.source)(this.env, context.get(`page`), `link`, new Map([]), `any`, false, false, false), this.traceableMethod(this.getAttribute, 19, this.source)(this.env, this.traceableMethod(this.getAttribute, 19, this.source)(this.env, (context.has(`pagination`) ? context.get(`pagination`) : null), `next`, new Map([]), `any`, false, false, false), `link`, new Map([]), `any`, false, false, false)))) {
                        this.echo(`          <a class="c-pagination__action is-next" href="`);
                        this.echo(this.env.getFilter('escape').traceableCallable(20, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 20, this.source)(this.env, context.get(`page`), `link`, new Map([]), `any`, false, false, false), `html`, null, true]));
                        this.echo(`">
            <span class="u-hidden-visually">Next: Page</span>
            <span class="c-pagination__number">`);
                        this.echo(this.env.getFilter('escape').traceableCallable(22, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 22, this.source)(this.env, context.get(`page`), `title`, new Map([]), `any`, false, false, false), `html`, null, true]));
                        this.echo(`</span>
          </a>
        `);
                    }
                    else if (this.traceableMethod(this.getAttribute, 24, this.source)(this.env, context.get(`page`), `link`, new Map([]), `any`, false, false, false)) {
                        this.echo(`          <a class="c-pagination__action" href="`);
                        this.echo(this.env.getFilter('escape').traceableCallable(25, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 25, this.source)(this.env, context.get(`page`), `link`, new Map([]), `any`, false, false, false), `html`, null, true]));
                        this.echo(`">
            <span class="u-hidden-visually">Page</span>
            <span class="c-pagination__number">`);
                        this.echo(this.env.getFilter('escape').traceableCallable(27, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 27, this.source)(this.env, context.get(`page`), `title`, new Map([]), `any`, false, false, false), `html`, null, true]));
                        this.echo(`</span>
          </a>
        `);
                    }
                    else {
                        this.echo(`          `);
                        this.echo(`          <span class="c-pagination__action">
            `);
                        this.echo(this.env.getFilter('escape').traceableCallable(32, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 32, this.source)(this.env, context.get(`page`), `title`, new Map([]), `any`, false, false, false), `html`, null, true]));
                        this.echo(`
          </span>
        `);
                    }
                    this.echo(`      </li>
    `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('page');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`  </ul>
</nav>
`);
            }

            getTemplateName() {
                return `b6412664fd621b9a933b0df64f139b518dfff1674c5351bcae689d197f42f78a`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `b6412664fd621b9a933b0df64f139b518dfff1674c5351bcae689d197f42f78a`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'b6412664fd621b9a933b0df64f139b518dfff1674c5351bcae689d197f42f78a');

let template = env.loadTemplate('b6412664fd621b9a933b0df64f139b518dfff1674c5351bcae689d197f42f78a');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/pagination/pagination.twig", args: context }
     );
     return rendered;;
};